const currency_preference = "currency_preference";
const portal = "portal";
const client = "client";
const id = "id";

export const apiUrlConstant = {
  verifyOTP: "verifyOTP",
  verifyUpdateOtp: "verifyUpdateOtp",
  sendOTP: "sendOTP",
  getDashboardData: `dashboardData?${currency_preference}=`,
  getPortfolioData: `userPortfolio?${portal}=${client}&`,
  getWallet: `wallet?${currency_preference}=`,
  exploreCrypto: `exploreToken?${currency_preference}=`,
  popularCoin: `popularCoin`,
  trendingCoin: `trendingCoin`,
  featuredcoin: `featuredcoin`,
  favorite: "favorite",
  getBanks: "bank",
  deleteCard: "deleteCard",
  getProfileData: `userInfo?${portal}=`,
  updateUserInfo: `userInfo?${portal}=`,
  buyWebToken: "buyTokenWebhook",
  buyToken: "buyToken",
  sellToken: "sellToken",
  directBuySell: "directBuySell",
  addBank: "bank",
  deleteBank: "bank",
  withdraw: "withdraw",
  getStatus: `userStatus?${portal}=${client}`,
  updatePhoneOrEmail: "phoneOrEmail",
  changePassword: "changePassword",
  updateVerifiedPhoneOrEmail: "updateVerifiedPhoneOrEmail",
  getWatchList: "getWatchList",
  watchlist: "watchlist",
  getTokenDetails: `tokendetails?${id}=`,
  getTokenData: `tokendetails`,
  getTokenChart: `gettokenchart?${id}=`,
  getTokenChartDetails: `gettokenchart`,
  getTokenWatchlist: `tokeninwatchlist?${id}=`,
  getTokenPrice: "gettokenprice",
  contactUs: "contact",
  validate2fa: "validate2fa",
  create2fa: "create2fa",
  skip2fa: "skip2fa",
  disable2fa: "disable2fa",
  orders: "orders",
  tradeHistory: "trade",
  orderEndpoints: {
    featureEndpoint: "order",
    cancelOrder: "order/cancel",
  },
  marketEndpoints: {
    featureEndpoint: "market",
    depth: "market/depth",
    trade: "market/trade",
  },
  pair: {
    balance: "trade-pair-wallet"
  }
};
